import React from 'react'
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, ListGroup, ListGroupItem, ListGroupItemHeading, Table } from 'reactstrap'
import tapOrClick from 'react-tap-or-click'
import Loader from 'react-loader-spinner'
import { Controller, User } from '../../../models'
import { WS_URL, getController, getTeam, planlist } from "../../../api"
import { authRedirect, getStorage, loadUser } from "../../../dataHelpers/authenticationHelpers"
import { getMySubscriptionPlan, getPaymentHistory } from "../../../dataHelpers/subscriptionHelpers"
import Websocket from "react-websocket"
import { subscriptionHelpers } from '../../../dataHelpers'
import { ErrorModal } from '../../ui'
import DashboardIcon from 'react-icons/lib/fa/dashboard'
import TrendsIcon from 'react-icons/lib/fa/line-chart'
import LogsIcon from 'react-icons/lib/fa/book'
import AboutIcon from 'react-icons/lib/fa/info-circle'
import SquareIcon from 'react-icons/lib/fa/square'
import TeamIcon from 'react-icons/lib/fa/group'
import FieldIcon from 'react-icons/lib/fa/map-pin'
import SubscribedIcon from 'react-icons/lib/fa/bell'
import classnames from 'classnames'
import { SUBS_PLAN_NOT_ASSIGN, PAY_DATA_NOT_FOUND } from '../../../constants'
import {pageHelpers} from '../'
import '../../../stylesheets/odometer-theme-default.css'
import '../../../stylesheets/ControllerDashboard.css'

class ControllerSubscriptionDetails extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        let {token, user} = props
        user = user || new User()
        let controllerID = this.urlParams.controller_id

        this.state = {
            controller: null,
            loading: false,
            activeTab: '5',
            errors: [],
            subscriptionDetails: null,
            subsPlanName: '',
            isSeasonedPlan: '',
            subsPaymentData: [],
            dealersList: [],
            remainingDays: 0,
            token,
            user,
            controllerID,
        }

        this.fetchController = this.fetchController.bind(this)
        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.dismissError = this.dismissError.bind(this)
    }

    async componentDidMount() {
        let {token, user} = this.state
        if (user && !user.canViewControllers) {
            authRedirect('/unauthorized', this.props.history)
        }
        await this.fetchController()
        await this.getDealers(token)
    }

    async componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)
        let {token, user} = nextProps
        user = user || new User()
        let controllerID = this.urlParams.controller_id
        this.setState({token, user, controllerID})
    }

    async getDealers(token) {
        try {
            let dealersData = await subscriptionHelpers.getDealersList(token)
            if (!dealersData.error) {
                this.setState({ dealersList: dealersData.map((e) => e.email) })
            } else {
                this.setState({ errors: [dealersData.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    async fetchController() {
        try {
            let controllerId
            let {token, controllerID} = this.state
            if (controllerID) {
                if (controllerId) {
                    this.getRemainingdays(token, controllerId)
                    this.getSubscriptionData(token, controllerId)
                    this.getPaymentData(token, controllerId)
                }
            } else {
                authRedirect('/', this.props.history)
            }
            let controller = await getController(token, controllerId)
            let teamName = this.state.teamName
            if (controller.team) {
                let team = await getTeam(token, controller.team, 'pico')
                teamName = team.name
            }
            await this.setState({ controller, teamName })
        } catch (error) {
            console.log(error)
        }
        this.setState({ loading: false })
    }

    async getRemainingdays(token, controllerId) {
        try {
            let controller = await getController(token, controllerId)
            if (!controller.error) {
                this.setState({ remainingDays: controller.freeDaysRemaining })
            }
        } catch (error) {
            console.log(error)
        }
    }

    async getSubscriptionData(token, controllerId) {
        try {
            let subscriptionData = await getMySubscriptionPlan(token, controllerId)
            if (!subscriptionData.error) {
                if (subscriptionData.subscription_plan) {
                    let {token} = this.state
                    let subsPlan = await planlist(token)
                    {
                        (subsPlan.map((plan) =>
                            (plan.id == subscriptionData.subscription_plan ? this.setState({ subsPlanName: plan.name, isSeasonedPlan: plan.is_seasoned }) : '')
                        ))
                    }
                }
                this.setState({ subscriptionDetails: subscriptionData })
            } else {
                this.setState({ errors: [subscriptionData.error] })
            }
        } catch (error) {
            console.log(error)
        }
        this.setState({ loading: false })
    }

    async getPaymentData(token, controllerId) {
        try {
            let paymentDataResponse = await getPaymentHistory(token, controllerId)
            if (!paymentDataResponse.error) {
                if (paymentDataResponse.length > 0) {
                    await this.setState({ subsPaymentData: paymentDataResponse, loading: false })
                } else {
                    //let appError = new AppError("No Found", `Payment history not found for this controller.`)
                    //await this.setState({errors: [appError], loading: false, paymentHistoryData : ''})                    
                }
            } else {
                this.setState({ errors: [paymentDataResponse.error] })
            }
        } catch (error) {
            console.log(error)
        }
        this.setState({ loading: false })
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors })
    }

    async handleWebSocketResponse(data) {
        let controller = Controller.fromAPIObject(JSON.parse(data))
        let {token, teamName} = this.state
        if (controller.team) {
            let team = await getTeam(token, controller.team, 'pico')
            teamName = team.name
        }
        this.setState({ controller, teamName })
    }

    IsJsonString(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }

    render() {
        let controller = this.state.controller || new Controller()
        let { token, user, controllerID, errors, loading, teamName, subscriptionDetails, subsPlanName, isSeasonedPlan, subsPaymentData, dealersList, remainingDays } = this.state
        return (<div>
            <div className="row justify-content-start">
                {(loading ? null : <h2 className="col-6 text-left"><SquareIcon />&ensp;{controller.userIdentifiableName}</h2>)}
                {(loading || !controller.field ? null : <h2 className="col-6 text-left"><FieldIcon />&ensp;Field&nbsp;#{controller.field.field_number}&ensp;{controller.field.name}</h2>)}
                {(!loading && user && user.isSupport ? <small className="text-muted col-6 offset-6 text-left"><TeamIcon className='ml-2 mr-4' />&ensp;{teamName}</small> : null)}
            </div>
            <br />
            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === '1' })}
                        {...tapOrClick(() => { authRedirect(`/controllers/${controllerID || controller.id}`, this.props.history) })}>
                        <DashboardIcon />&ensp;Dashboard
                    </NavLink>
                </NavItem>
                {(user.canViewData || user.isSupport ?
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { authRedirect(`/controllers/${controllerID || controller.id}/trends`, this.props.history) })}>
                            <TrendsIcon />&ensp;Trends
                        </NavLink>
                    </NavItem> :
                    null)}
                {(user.canViewData || user.isSupport ?
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { authRedirect(`/controllers/${controllerID || controller.id}/logs`, this.props.history) })}>
                            <LogsIcon />&ensp;Logs
                        </NavLink>
                    </NavItem> :
                    null)}
                <NavItem>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === '4' })}
                        {...tapOrClick(() => { authRedirect(`/controllers/${controllerID || controller.id}/about`, this.props.history) })}>
                        <AboutIcon />&ensp;About
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classnames({ active: this.state.activeTab === '5' })}
                        {...tapOrClick(() => { authRedirect(`/controllers/${controllerID || controller.id}/subscription`, this.props.history) })}>
                        <SubscribedIcon />&ensp;Subscription
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                    <Row>
                    </Row>
                </TabPane>
                <TabPane tabId="2">
                    <Row>
                    </Row>
                </TabPane>
                <TabPane tabId="3">
                    <Row>
                    </Row>
                </TabPane>
                <TabPane tabId="4">
                    <Row>
                    </Row>
                </TabPane>
                <TabPane tabId="5">
                    <Row>
                        {(loading ? <div className="m-5 col-12 align-content-center text-center justify-content-center"><Loader type="TailSpin" width={60} height={60} /></div> :
                            <div className="d-flex col-12 bg-light border">
                                <div className="col-5">
                                    <ListGroup className="align-self-center m-3 text-left">
                                        <ListGroupItem className="bg-light">
                                            <ListGroupItemHeading className="text-center font-weight-bold">Subscription Details</ListGroupItemHeading>
                                        </ListGroupItem>
                                        {subscriptionDetails ?
                                            <div>
                                                <ListGroupItem><strong>Subscription Plan :</strong> {subsPlanName}</ListGroupItem>
                                                <ListGroupItem><strong>Team :</strong> {teamName}</ListGroupItem>
                                                <ListGroupItem><strong>Start Date :</strong> {new Date(subscriptionDetails.start_date).toISOString().slice(0, 10)}</ListGroupItem>
                                                {!isSeasonedPlan ?
                                                    <div>
                                                        <ListGroupItem><strong>Remaining days : </strong>
                                                            {/* {subscriptionDetails.remaining_days == null ? '0' : subscriptionDetails.remaining_days} */}
                                                            {remainingDays}
                                                        </ListGroupItem>
                                                        <ListGroupItem><strong>Extended days :</strong> {subscriptionDetails.extended_days}</ListGroupItem>
                                                    </div> :
                                                    <ListGroupItem><strong>End Date :</strong> {new Date().getFullYear() + '-12-31'}</ListGroupItem>
                                                }
                                            </div>
                                            : <div>
                                                <ListGroupItem>{SUBS_PLAN_NOT_ASSIGN}</ListGroupItem>
                                            </div>
                                        }

                                    </ListGroup>
                                </div>
                                <div className="col-7 pay-mar-top">
                                    <ListGroup className="align-self-center">
                                        <ListGroupItem className="bg-light">
                                            <ListGroupItemHeading className="text-center font-weight-bold">Payment Details</ListGroupItemHeading>
                                        </ListGroupItem>
                                        {<div class="table-responsive">
                                            <Table className="customTable">
                                                <tbody>
                                                    <tr>
                                                        <th>Transaction ID</th>
                                                        <th>Paid By</th>
                                                        <th>Amount</th>
                                                        <th>Payment Date</th>
                                                    </tr>
                                                    {(subsPaymentData && subsPaymentData.length > 0) ? subsPaymentData.map((p, idx) => {
                                                        let detail = this.IsJsonString(p.detail)
                                                        return (
                                                            <tr key={`${p.id}-${idx}`}>
                                                                <td>{p.random_transaction_id}</td>
                                                                <td>{p.paid_by}</td>
                                                                <td>
                                                                    {
                                                                        dealersList.indexOf(p.paid_by) !== -1 ? '--' : (detail ? ('$ ' + (detail.amount) / 100) : '')
                                                                    }
                                                                </td>
                                                                <td>{new Date(p.payment_date).toISOString().slice(0, 10)}</td>
                                                            </tr>
                                                        )
                                                    }) :
                                                        <tr>
                                                            <td colSpan='4'>{PAY_DATA_NOT_FOUND}</td>
                                                        </tr>}
                                                </tbody>
                                            </Table>
                                        </div>
                                        }

                                    </ListGroup>
                                </div>
                                {(errors.map((appError, idx) =>
                                    <ErrorModal key={idx} modal={true} toggle={() => (this.dismissError(appError))} text={appError.text} title={appError.title} />
                                ))}
                                {(controller.id ?
                                    <Websocket url={`${WS_URL}/controllers/${controller.id}/?access_token=${token.accessToken}`}
                                        onMessage={this.handleWebSocketResponse} /> : null)}
                            </div>

                        )}
                    </Row>
                </TabPane>
            </TabContent>
        </div>)
    }
}
export default ControllerSubscriptionDetails



// WEBPACK FOOTER //
// ./src/components/pages/subscription/ControllerSubscriptionDetails.js